export default __webpack_public_path__ + "static/media/Taboola_logo.9efc9c61.svg";